import {
    Box,CircularProgress,
} from "@mui/material";
import {useEffect, useState} from "react";
import Typography from "@mui/material/Typography";
import useApiHook from "../../hooks/useApiHook";

const EmailVerificationModal = (props) => {
    const token = props.token;
    const { makeRequest, response, error } = useApiHook();
    const [status, setStatus] = useState('initial');

    useEffect(() => {
        makeRequest('/auth/verify-email', 'get', { token });
    }, [makeRequest, token]);

    useEffect(() => {
        if (error) {
            if (error.error.code === 410) { // Token expired
                return props.onClose('token_expired');
            }
            return props.onClose('token_not_valid');
        } else if (response) {
            if (response.state === 'success'){
                return props.onClose('token_verified');
            }
            return props.onClose('token_not_valid');
        }
    }, [response, error]);

    return <>
        <Box display='flex' flexDirection={'column'} justifyContent={'center'} alignItems={'center'}>
            <CircularProgress />
            <Typography variant='h6'>Verifica email in corso...</Typography>
        </Box>
    </>
}

export default EmailVerificationModal;
